import { ShareModal } from '../components/modals/Share'
import { IS_SSR, Settings } from '@/config'
import { APIClient } from '@/services'
import { t } from '@lingui/core/macro'

type ShareContent = {
  message: string
  url: string
  title: string
}

const getWebsite = () => {
  if (IS_SSR) return ''

  return window?.location?.origin
}

const share = async (content: ShareContent) => {
  if (!navigator) return

  const isMobileShare = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))

  const shareData: ShareData = {
    text: content?.message,
    url: content?.url,
    title: content?.title,
  }

  const shareable = (!!navigator.share && navigator.canShare(shareData)) && isMobileShare

  if (!shareable) {
    ShareModal.open({ data: shareData })
  } else {
    await navigator.share(shareData)
  }
}

export const sharePost = (post: APIClient.Post.Post) => {
  const address = `${getWebsite()}/crud/${post?.id}`

  const message = t`Check out this post ${post.title} on ${Settings.AppName}!`

  share({
    message,
    url: address,
    title: post.title,
  })
}

export const Share = {
  getWebsite,
  post: sharePost,
}